import React from 'react';
import { Link } from 'react-router-dom';

import shapeImg from '../../assets/img/newsletter/shape-6-2.png';

const Service = () => {
  return (
    <div className="it-service-5-area p-relative fix z-index black-bg">
      <div className="it-service-5-shape-1">
        <img src={shapeImg} alt="" />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
            <div className="it-service-5-item text-center text-lg-end item-style-1">
              <div className="it-service-5-icon">
                <i className="flaticon-fast-delivery"></i>
              </div>
              <div className="it-service-5-content">
                <h5>
                  <Link to="/service-details" className="hover-anim white">
                    Fast Delivery
                  </Link>
                </h5>
                <p>
                  Lorem ipsum dolor sit amet <br />
                  consectetur.
                </p>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
            <div className="it-service-5-item text-center text-lg-end item-style-2">
              <div className="it-service-5-icon">
                <i className="flaticon-shopping-cart"></i>
              </div>
              <div className="it-service-5-content">
                <h5>
                  <Link to="/service-details" className="hover-anim white">
                    Free delivery
                  </Link>
                </h5>
                <p>
                  Lorem ipsum dolor sit amet <br />
                  consectetur.
                </p>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
            <div className="it-service-5-item text-center text-lg-end item-style-3">
              <div className="it-service-5-icon">
                <i className="flaticon-customer-service"></i>
              </div>
              <div className="it-service-5-content">
                <h5>
                  <Link to="/service-details" className="hover-anim white">
                    Online Support
                  </Link>
                </h5>
                <p>
                  Lorem ipsum dolor sit amet <br />
                  consectetur.
                </p>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
            <div className="it-service-5-item item-style-4 d-flex justify-content-xl-end justify-content-lg-start justify-content-center align-items-center">
              <div className="text-lg-end text-center">
                <div className="it-service-5-icon">
                  <i className="flaticon-sale"></i>
                </div>
                <div className="it-service-5-content">
                  <h5>
                    <Link to="/service-details" className="hover-anim white">
                      Special Offers
                    </Link>
                  </h5>
                  <p>
                    Lorem ipsum dolor sit amet <br />
                    consectetur.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
